import SectionVisible from 'appContainer/SectionVisible';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { MarkdownRenderer, Stack, Typography } from 'styles';
import { IHistoryItem } from 'types/History';
import { SECTIONS } from 'types/SectionsVisibility';
import { useTranslation } from 'utils/translations';

type Props = {
	item: IHistoryItem;
};

const ClaimContent = ({ item }: Props) => {
	const { claimData: claim } = useSelector((store: RootState) => store.claim);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});

	return (
		<Stack gap="5px">
			<Typography variant="body">
				{tClientLabels('claim.history.claimStatusChanged', {
					status: tDbLabels(item.label),
				})}
			</Typography>

			{item.reasonCode && item.reasonCodeLabel && (
				<Typography
					variant="body"
					sx={{
						'& > p': { padding: 0, margin: 0 },
						'& > ul': { margin: 0, paddingLeft: '20px' },
						'& > ul > li > p': { padding: 0, margin: 0 },
					}}
				>
					<MarkdownRenderer>
						{tClientLabels('claim.history.reasonCode', {
							reasonCode: tDbLabels(item.reasonCodeLabel),
						})}
					</MarkdownRenderer>
				</Typography>
			)}

			{item.internalNote && (
				<>
					<SectionVisible
						sectionName={SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS}
						carrier={{ customLayout: claim.customLayout }}
					>
						<Typography
							variant="body"
							sx={{
								'& > p': { padding: 0, margin: 0 },
								'& > ul': { margin: 0, paddingLeft: '20px' },
								'& > ul > li > p': { padding: 0, margin: 0 },
							}}
						>
							<MarkdownRenderer>
								{tClientLabels('claim.history.argument', {
									argument: item.internalNote,
								})}
							</MarkdownRenderer>
						</Typography>
					</SectionVisible>
					<SectionVisible
						sectionName={SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS}
						carrier={{ customLayout: claim.customLayout }}
					>
						<Typography
							variant="body"
							sx={{
								'& > p': { padding: 0, margin: 0 },
								'& > ul': { margin: 0, paddingLeft: '20px' },
								'& > ul > li > p': { padding: 0, margin: 0 },
							}}
						>
							<MarkdownRenderer>
								{tClientLabels('claim.history.denialReason', {
									reasonText: item.internalNote,
								})}
							</MarkdownRenderer>
						</Typography>
					</SectionVisible>
				</>
			)}
		</Stack>
	);
};

export default ClaimContent;
